import { create } from "zustand"
import { persist } from "zustand/middleware"

import { useAuthStore } from "./auth"

interface ImageSearchDiagnosticsState {
  enabledByUser: Record<number, boolean>
  setEnabled: (userId: number, enabled: boolean) => void
}

export const useImageSearchDiagnosticsStore = create<ImageSearchDiagnosticsState>()(
  persist(
    (set) => ({
      enabledByUser: {},
      setEnabled: (userId, enabled) =>
        set((state) => ({ enabledByUser: { ...state.enabledByUser, [userId]: enabled } })),
    }),
    { name: "imageSearchDiagnostics" }
  )
)

export function useImageSearchDiagnosticsEnabled() {
  const user = useAuthStore((state) => state.user)
  const enabled = useImageSearchDiagnosticsStore((state) =>
    user ? state.enabledByUser[user.id] === true : false
  )
  return user?.is_admin === true && enabled
}
